export default __webpack_public_path__ + "static/media/cp_geo_az.302b01b5.svg";